// İki ayrı Audio instance (üst üste çalmasın diye tekil tutuyoruz)
const instances = {
  support: null,
  message: null,
};

const SOURCES = {
  support: "/sounds/2.wav", // destek talebi sesi
  message: "/sounds/3.wav", // mesaj sesi
};

/**
 * Belirtilen türde bildirim sesi çalar.
 * @param {"support" | "message"} type
 */
export function playNotificationSound(type) {
  try {
    const src = SOURCES[type];
    if (!src) return;

    if (!instances[type]) {
      instances[type] = new Audio(src);
      instances[type].volume = 0.7;
    }

    const audio = instances[type];
    audio.currentTime = 0;
    audio.play().catch((err) => {
      console.warn(`Notification sound (${type}) blocked:`, err?.message);
    });
  } catch (err) {
    console.warn("playNotificationSound error:", err);
  }
}

/**
 * Kullanıcı ilk etkileşiminde her iki sesi de "unlock" et.
 * Autoplay politikasını aşmak için.
 */
export function unlockAudio() {
  ["support", "message"].forEach((type) => {
    try {
      const src = SOURCES[type];
      const a = new Audio(src);
      a.volume = 0;
      a.play()
        .then(() => {
          a.pause();
          a.currentTime = 0;
        })
        .catch(() => {});
    } catch {}
  });
}

/**
 * Sadece sekme arka plandayken çal.
 * @param {"support" | "message"} type
 */
export function playIfBackground(type) {
  if (typeof document !== "undefined" && document.hidden) {
    playNotificationSound(type);
  }
}
